import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';
import gql from 'graphql-tag';

Vue.localStorage.last_viewed_products_list = {
    type: Object,
    default: {
        products: {}
    }
};

export default {
    namespaced: true,
    state: {
        product: {},
        amountValue: 1,
        currentMerchantId: null,
        currentProductId: null,
        showOutOfStockModal: false,
        showLimitPerOrderModal: false,
        showInCartModal: false,
        inCartMessage: '',
        currentLinkMerchant: null,
        shippingPrices: {},
        shippingEstimationDates: {},
        contactForm: {
            firstname: null,
            lastname: null,
            email: null,
            phone: null,
            comment: null,
            product_id: null,
            merchant_id: null
        },
        contactFormResult: {},
        displayBuyOptionsModal: false,
        variantsConfig: {},
        variantIds: [],
        pricesLoading: false,
        pricesLoaded: false,
    },
    getters: {
        getProduct: state => state.product,
        getAmountValue: state => state.amountValue,
        getCurrentMerchantId: state => state.currentMerchantId,
        currentProductId: state => state.currentProductId ? state.currentProductId.toString() : state.currentProductId,
        getProductImage: state => (productId) => {
            let result;
            if (
                state.product.images.images_positions &&
                state.product.images.images_positions[productId]
            ) {
                const images = state.product.images.images_positions[productId];
                let defaultImage;
                for (const image of images) {
                    if (!defaultImage || defaultImage.ordering > image.ordering) {
                        defaultImage = image;
                    }
                }
                if (defaultImage) {
                    for (const image of state.product.images.product_images) {
                        if (image.original_image_path == defaultImage.image) {
                            result = image;
                            break;
                        }
                    }
                }
            }
            // for (const image of state.product.images.product_images) {
            //     if (image.products.includes(`${productId}`)) {
            //         result = image;
            //         break;
            //     }
            // }
            return result;
        },
        currentMerchantData: state => (product, currentMerchantId) => {
            let result = null;

            currentMerchantId = currentMerchantId || state.currentMerchantId;
            product = product || state.product;

            if (currentMerchantId && product && product.merchant[currentMerchantId] !== undefined) {
                result = product.merchant[currentMerchantId];
            }

            return result;
        },
        isSellOutOfStock: (state, getters) => (product, currentProductId, merchantId) => {
            let sellOutOfStock = null;
            let currentMerchantData = getters.currentMerchantData(product, merchantId);

            currentProductId = currentProductId || state.currentProductId;

            if (currentMerchantData && currentMerchantData.sellOutOfStock[currentProductId] !== undefined) {
                sellOutOfStock = currentMerchantData.sellOutOfStock[currentProductId];
            }

            return sellOutOfStock;
        },
        merchantQuota: (state, getters) => (product, currentProductId, merchantId) => {
            let merchantsQuota = null;
            let currentMerchantData = getters.currentMerchantData(product, merchantId);

            currentProductId = currentProductId || state.currentProductId;

            if (currentMerchantData && currentMerchantData.quota[currentProductId] !== undefined) {
                merchantsQuota = currentMerchantData.quota[currentProductId];
            }

            return merchantsQuota;
        },
        getDiscountRate: () => (priceData) => {
            if (!priceData.discount_abs_val) {
                return priceData.discount * 100;
            } else {
                return Math.round(100 - (priceData.price * 100 / priceData.original_price_inkl_vat));
            }
        },
        price: (state, getters) => (product, productId, merchant) => {
            const merchantData = getters.currentMerchantData(product, merchant);
            if (!productId) {
                productId = state.currentProductId;
            }
            if (merchantData && merchantData.price && merchantData.price[productId]) {
                return merchantData.price[productId].price;
            }
        },
        tierPrices: (state, getters) => (product, productId, merchant) => {
            const merchantData = getters.currentMerchantData(product, merchant);
            if (!productId) {
                productId = state.currentProductId;
            }
            if (merchantData && merchantData.tierPrice && merchantData.tierPrice[productId]) {
                return merchantData.tierPrice[productId];
            }
        },
        currentProductAttributes: state => (product, currentProductId) => {
            product = product || state.product;
            currentProductId = currentProductId || state.currentProductId;

            let result = {};
            if (
                currentProductId !== undefined &&
                product &&
                product.variants !== undefined &&
                product.variants.mapper !== undefined
            ) {
                let mapper = product.variants.mapper;
                for (const indexname of Object.keys(mapper)) {
                    for (const key of Object.keys(mapper[indexname])) {
                        if (mapper[indexname][key].toString() === currentProductId.toString()) {
                            result[indexname] = key;
                        }
                    }
                }
            }

            return result;
        },
        currentProductAttributesLabels: (state, getters) => {
            const result = {};
            const product = state.product;
            const attributes = getters.currentProductAttributes();
            const variantAttributes = getters.getProductVariantAttributes(product);
            for (const indexname of Object.keys(attributes)) {
                const value = attributes[indexname];
                if (variantAttributes && variantAttributes[indexname] && variantAttributes[indexname].values[value]) {
                    result[variantAttributes[indexname].label] = variantAttributes[indexname].values[value];
                }
            }

            return result;
        },
        getProductVariantAttributes: () => product => {
            const lang = Vue.$language.getLanguage();
            let variantAttributes = {};
            if (product && product.variants && product.variants.variant_attributes) {
                if (product.variants.variant_attributes[lang]) {
                    variantAttributes = product.variants.variant_attributes[lang];
                } else {
                    variantAttributes = Object.values(product.variants.variant_attributes)[0];
                }
            }
            return variantAttributes;
        },
        currentLinkMerchant: state => state.currentLinkMerchant,
        shippingPrices: state => state.shippingPrices,
        shippingEstimationDates: state => state.shippingEstimationDates,
        contactFormResult: state => state.contactFormResult,
        getExistingBasketItem: (state, getters) => (options) => {
            const basketItem = getters.getBasketItem(options);
            const hash = Vue.$basket.getItemHash(basketItem);
            return Vue.$basket.getBasketItem(hash);
        },
        getBasketItem: (state, getters) => ({
            onlyAvailableQuantity,
            product,
            currentProductId,
            currentMerchantId,
            quantity,
            options,
            buyOptions,
        }) => {
            product = product || state.product;
            currentProductId = currentProductId || state.currentProductId;
            currentMerchantId = currentMerchantId || state.currentMerchantId;
            onlyAvailableQuantity = onlyAvailableQuantity || false;

            let amountValue = onlyAvailableQuantity ?
                getters.merchantQuota(product, currentProductId, currentMerchantId) :
                (quantity || getters.getAmountValue);
            let attributes = getters.currentProductAttributes(product, currentProductId);

            let item = {};
            item.product_id = product.id;
            item.catalog_item_id = currentProductId.toString();
            item.options = {
                merchant: currentMerchantId,
                fees: Vue.$basket.getBasketItemFees({
                    product: product,
                    buyOptions,
                }),
                ...options,
            };
            if (product.hasOwnProperty('boundCoupon')) {
                item.options.boundCoupon = product.boundCoupon;
            }
            item.quantity = amountValue;
            item.product = product;
            item.price = product.merchant[currentMerchantId].price[currentProductId].price;
            item.rrp_price = product.merchant[currentMerchantId].price[currentProductId].original_price_inkl_vat;
            item.buyOptions = buyOptions;

            item.attributes = {};
            for (const key of Object.keys(attributes)) {
                item.attributes[key] = attributes[key];
            }
            return item;
        },
        isProductBuyable: (state, getters) => (product, currentMerchantId, currentProductId) => {
            let result = false;

            product = product || state.product;
            currentProductId = currentProductId || state.currentProductId;
            currentMerchantId = currentMerchantId || state.currentMerchantId;

            const currentMerchantData = getters.currentMerchantData(product, currentMerchantId);

            if (
                product &&
                currentProductId &&
                currentMerchantId &&
                (!product.hasOwnProperty('isNotBuyable') || !product.isNotBuyable[currentProductId]) &&
                currentMerchantData &&
                currentMerchantData.productAttributes &&
                currentMerchantData.productAttributes[currentProductId] &&
                (currentMerchantData.productAttributes[currentProductId].length === 0 ||
                    currentMerchantData.productAttributes[currentProductId]['mb.is_not_buyable_merchant'] != true)
            ) {
                let merchantsQuota = getters.merchantQuota(product, currentProductId, currentMerchantId);
                if (merchantsQuota === null || merchantsQuota > 0) {
                    result = true;
                } else {
                    let sellOutOfStock = getters.isSellOutOfStock(product, currentProductId, currentMerchantId);
                    if (sellOutOfStock) {
                        result = true;
                    }
                }
            }
            return result;
        },
        getProductAttributeByLanguage: () => (product, attribute) => {
            const lang = Vue.$language.getLanguage();
            let attributes = {};
            if (product && product.attributes) {
                if (lang && product.attributes.hasOwnProperty(lang)) {
                    attributes = product.attributes[lang];
                } else {
                    attributes = Object.values(product.attributes)[0];
                }
            }
            if (attributes && attribute) {
                return attributes.hasOwnProperty(attribute) ? attributes[attribute] : '';
            } else {
                return attributes;
            }
        },
    },
    mutations: {
        setProduct(state, {product, silent}) {
            Vue.set(state, 'product', product ? product : null);
            if (!silent) {
                Vue.set(state, 'currentProductId', product && product.hasOwnProperty('id') ? product.id : null);
            }
        },
        setAmountValue(state, value) {
            state.amountValue = parseInt(value);
        },
        resetAmountValue(state) {
            state.amountValue = 1;
        },
        setCurrentMerchantId(state, value) {
            state.currentMerchantId = value;
        },
        setCurrentProductId(state, value) {
            state.currentProductId = value;
        },
        setShowOutOfStockModal(state, value) {
            state.showOutOfStockModal = value;
        },
        setShowLimitPerOrderModal(state, value) {
            state.showLimitPerOrderModal = value;
        },
        setShowInCartModal(state, value) {
            state.showInCartModal = value;
        },
        setInCartMessage(state, value) {
            state.inCartMessage = value;
        },
        setCurrentLinkMerchant(state, value) {
            if (value) {
                state.currentLinkMerchant = value;
            }
        },
        setShippingPrices(state, value) {
            state.shippingPrices = value;
        },
        setShippingEstimationDates(state, value) {
            let result = {};
            if (value) {
                if (value.estimation) {
                    result.estimation = {};
                    for (const merchantId of Object.keys(value.estimation)) {
                        result.estimation[merchantId] = value.estimation[merchantId][value.productId];
                    }
                }
                if (value.delayed) {
                    result.delayed = {};
                    for (const merchantId of Object.keys(value.delayed)) {
                        result.delayed[merchantId] = value.delayed[merchantId][value.productId];
                    }
                }
                if (value.pickup) {
                    result.pickup = {};
                    for (const merchantId of Object.keys(value.pickup)) {
                        result.pickup[merchantId] = value.pickup[merchantId][value.productId];
                    }
                }
            }
            state.shippingEstimationDates = Object.assign({}, state.shippingEstimationDates);
            state.shippingEstimationDates[value.productId] = result;
        },
        updateContactForm(state, value) {
            if (value.property) {
                state.contactForm[value.property] = value.value;
            }
        },
        clearContactForm(state) {
            for (const i of Object.keys(state.contactForm)) {
                state.contactForm[i] = null;
            }
        },
        clearContactFormResult(state) {
            state.contactFormResult = {};
        },
        setContactFormResult(state, value) {
            let result = {};
            if (typeof value == 'string') {
                try {
                    result = JSON.parse(value);
                } catch (e) {
                    result = {};
                }
            } else if (typeof value == 'object' && value !== undefined) {
                result = value;
            }

            if (result.result === undefined) {
                result.result = false;
            }

            state.contactFormResult = result;
        },
        setQuantity(state, quantity) {
            state.quantity = quantity;
        },
        setDisplayBuyOptionsModal(state, value) {
            state.displayBuyOptionsModal = value;
        },
        setVariantsConfig(state, value) {
            Vue.set(state.variantsConfig, value.key, value.value);
        },
        deleteVariantsConfig(state, value) {
            Vue.delete(state.variantsConfig, value.key, value.value);
        },
        resetVariantsConfig(state) {
            state.variantsConfig = {};
        },
        setVariantIds(state, value) {
            state.variantIds = value;
        },
        setPricesLoading: (state, value) => state.pricesLoading = value,
        setPricesLoaded: (state, value) => state.pricesLoaded = value,
    },
    actions: {
        buyProduct({ commit, getters, state, rootState }, options = {}) {
            const basketItem = getters.getBasketItem(options);
            let basketItemExists = false;
            if (options.silent) {
                const hash = Vue.$basket.getItemHash(basketItem);
                basketItemExists = Object.keys(Vue.$basket.getBasketItem(hash)).length > 0;
            }
            if (!basketItemExists) {
                if (!basketItem.product) {
                    basketItem.product = Object.assign({}, state.product);
                }
                return Vue.$basket.addBasketItem(
                    basketItem,
                    options.hasOwnProperty('silent') ? options.silent: false,
                    options.hasOwnProperty('keepProduct') ? options.keepProduct: false,
                ).then(() => {
                    if (!rootState.FloatingBasket) {
                        commit('setShowInCartModal', true);
                    }

                    return basketItem;
                });
            } else {
                return new Promise(() => {
                    return basketItem;
                });
            }
        },
        getShippingPrices({ commit }, params) {
            return Vue.$graphql
                .query({
                    query: gql`
                        query getProductMerchantShippingPrices($merchant: Int, $type: Int, $country: Int, $currency: String) {
                            getProductMerchantShippingPrices(merchant: $merchant, type: $type, country: $country, currency: $currency) {
                                id
                                value
                                country_id
                                minimum
                                shipping_time_from
                                shipping_time_to
                            }
                        }
                    `,
                    variables: {
                        ...params,
                        currency: Vue.$currency.getSelected()
                    },
                    fetchPolicy: 'no-cache',
                })
                .then(r => r.data.getProductMerchantShippingPrices)
                .then(result => {
                    commit('setShippingPrices', {
                        [params.merchant]: result ? result : {}
                    });
                })
                .catch(() => {
                    commit('setShippingPrices', {
                        [params.merchant]: {}
                    });
                });
        },
        loadShippingEstimationDates({ commit, getters }, params) {
            const productId = params.item || getter.currentProductId;

            if (!getters.shippingEstimationDates[productId]) {
                let merchantsShippingData;
                if (params.merchantIds && params.merchantIds.length && productId) {
                    merchantsShippingData = [];
                    for (const merchantId of Object.keys(getters.getProduct.merchant)) {
                        if (params.merchantIds.indexOf(merchantId) !== -1) {
                            let merchant = getters.getProduct.merchant[merchantId];
                            merchantsShippingData.push({
                                merchantId: merchantId,
                                shipping_type: merchant.shippingType[productId],
                                time_to_ship: merchant.timeToShip[productId],
                                delayed_time_to_ship: merchant.delayedTimeToShip[productId]
                            });
                        }
                    }
                }
                if (merchantsShippingData && Object.values(merchantsShippingData).length) {
                    return Vue.$graphql
                        .query({
                            query: gql`
                                query getShippingEstimation($productId: Int!, $data: [JSON!]!, $country: String) {
                                    getShippingEstimation(productId: $productId, data: $data, country: $country) {
                                        delayed
                                        estimation
                                        pickup
                                    }
                                }
                            `,
                            variables: {
                                productId: parseInt(productId),
                                data: merchantsShippingData,
                                country: Vue.$country.getCountry(),
                            },
                        })
                        .then(r => r.data.getShippingEstimation)
                        .then(result => {
                            commit('setShippingEstimationDates', {
                                ...result,
                                productId,
                            });
                        })
                        .catch(error => {
                            console.log(error.toString());
                        });
                }
            }
        },
        sendContactForm({ commit, state, getters }, options) {
            commit('clearContactFormResult');
            let params = new URLSearchParams();
            for (const key of Object.keys(state.contactForm)) {
                let value = state.contactForm[key];
                if (value) {
                    params.append(key, value);
                }
            }
            params.append('merchant_id', getters.getCurrentMerchantId);
            params.append('product_id', getters.currentProductId);
            params.append('form_type', options.formType);

            axios({
                method: 'post',
                url: '/lash/product-contact/product-contact',
                data: params,
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            })
                .then(response => {
                    if (response && response.request && response.request.response) {
                        commit('setContactFormResult', response.request.response);
                    }
                })
                .catch(() => {
                    commit('setContactFormResult', {
                        result: false
                    });
                });
        },
        updateProductViewStatistics({}, productId) {
            let params = {
                product_id: productId
            };
            axios({
                method: 'post',
                url: '/xapi/stats',
                data: params
            }).catch(response => {
                console.log(response.toString());
            });
        },
        syncLastViewedProducts({}, products) {
            let requestEndpoint = '/xapi/last-viewed-products';
            return axios
                .post(requestEndpoint, {
                    products: products,
                    paramsSerializer: function(requestParams) {
                        return qs.stringify(requestParams);
                    }
                })
                .then(r => r.data)
                .then(result => {
                    return result;
                })
                .catch(error => {
                    console.log(error.toString());
                });
        },
        toggleItemInWishlist({}, id) {
            let requestEndpoint = '/xapi/wishlist';
            return axios
                .post(requestEndpoint, {
                    product: id,
                    paramsSerializer: function(requestParams) {
                        return qs.stringify(requestParams);
                    }
                })
                .then(r => r.data)
                .then(result => {
                    return result;
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
};
